import CardList from "@organisms/CardList/CardList"
import { ObjectsData } from "@organisms/ObjectsView/ObjectsView.types"
import useInfiniteObjectsList from "@organisms/ObjectsView/hooks/useInfiniteObjectsList"

import withAlternativeStates from "@HOCs/withAlternativeStates"

import useCardsView from "./CardsView.context"
import { CardsViewListProps } from "./CardsView.types"
import CardsViewEmptyState from "./CardsViewEdgeStates/CardsViewEmptyState/CardsViewEmptyState"
import CardsViewErrorState from "./CardsViewEdgeStates/CardsViewErrorState/CardsViewErrorState"
import CardsViewHiddenByScheduleHorizonState from "./CardsViewEdgeStates/CardsViewHiddenByScheduleHorizonState/CardsViewHiddenByScheduleHorizonState"
import CardsViewLoadingState from "./CardsViewEdgeStates/CardsViewLoadingState/CardsViewLoadingState"
import CardsViewNoResultsState from "./CardsViewEdgeStates/CardsViewNoResultsState/CardsViewNoResultsState"
import CardsViewSkeletonCard from "./CardsViewEdgeStates/CardsViewSkeletonCard/CardsViewSkeletonCard"

// Feeds the CardList organism from the objects view and cards view contexts.
function CardsViewList(props: CardsViewListProps) {
    const { children: renderCard } = props

    const { displayedAttributes } = useCardsView()
    const listProps = useInfiniteObjectsList()

    return (
        <CardList {...listProps} loaderCard={<CardsViewSkeletonCard />}>
            {(row, cardProps) => renderCard(row, displayedAttributes, cardProps)}
        </CardList>
    )
}

const CardsViewListWithAlternativeStates = withAlternativeStates<CardsViewListProps>({
    LoadingState: CardsViewLoadingState,
    ErrorState: CardsViewErrorState,
    EmptyState: CardsViewEmptyState,
    NoResultsState: CardsViewNoResultsState,
    HiddenByScheduleHorizonState: CardsViewHiddenByScheduleHorizonState,
    SuccessState: CardsViewList,
})

// The HOC is not generic, so the row type is re-exposed here the way Table.Column<T> exposes its own.
export default CardsViewListWithAlternativeStates as <T extends ObjectsData = ObjectsData>(
    props: CardsViewListProps<T>,
) => JSX.Element | null
